<mat-sidenav-container (backdropClick)="closeMenu()">
  <mat-sidenav [mode]="isMobile() ? 'over' : 'side'" [opened]="isOpened()">
    <fc-sidebar class="h-full block pl-5" />
  </mat-sidenav>
  <mat-sidenav-content>
    <fc-header />
    <div class="site-main-section px-10 lg:px-4 pt-[30px] ml-0 sm:pt-1 sm:px-1 pb-7">
      <router-outlet />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
